import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	id: () => faker.number.int({ min: 100, max: 999 }).toString(),
	operationDate: () => faker.date.past(0.3, '2022-00-00'),
	operationHour: () =>
		faker.date.between({
			from: new Date().setHours(0, 0, 0, 0),
			to: new Date().setHours(23, 59, 59, 999),
		}),
	codNRBE: () => faker.number.int({ min: 100, max: 999 }).toString(),
	approvingCenter: () => faker.number.int({ min: 100, max: 999 }).toString(),
	chargeHold: {
		id: () => faker.string.uuid(),
		name: () => faker.lorem.words(3),
	},
	operationType: {
		id: () => faker.string.uuid(),
		name: () => faker.lorem.words(2),
	},
	billType: () => faker.lorem.words(8),
	installmentPurchaseId: () => faker.number.int({ min: 1000, max: 9999 }).toString(),
	brandCode: () => faker.number.int({ min: 10, max: 99 }).toString(),
	cardType: () => faker.lorem.word(8),
	creditDebit: {
		id: () => faker.number.int({ min: 1, max: 2 }).toString(),
		name: () => faker.helpers.arrayElement(['CREDIT', 'DEBIT']),
	},
	country: {
		id: () => faker.number.int({ min: 100, max: 999 }).toString(),
		name: () => faker.location.country(),
	},
	city: () => faker.location.city(),
	acquirerInstitution: () => faker.company.name(),
	terminalCod: () => faker.number.int({ min: 100000, max: 999999 }).toString(),
	merchantCode: () => faker.number.int({ min: 1000000, max: 9999999 }).toString(),
	merchantName: () => faker.company.name(),
	activityCode: () => faker.number.int({ min: 1000, max: 9999 }).toString(),
	amount: {
		amount: () => parseFloat(faker.finance.amount(1, 1000)),
		currency: { id: 'EUR' },
	},
	originalAmount: {
		amount: () => parseFloat(faker.finance.amount()) * -1,
		currency: {
			id: 'EUR',
		},
	},
	exchangeRate: 1,
	authoritationNumber: '123456',
	authoritationCenter: '01',
	debitAccount: 'ES4214650100909089090909',
	franchiseType: 1234,
	entryMode: 'Manual',
	responseCode: 1,
	transactionData: '',
});
